import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2/dist/sweetalert2.js';

import 'sweetalert2/src/sweetalert2.scss';

import { Full, Form, Row } from './loginCss';

class Login extends Component {
    componentDidMount() {
        axios.post('/api/check').then(res => {
            if(res.data.message === 'you Were authorized'){
                this.props.history.push('admin/home')
            }
        }).catch(e => {
            console.log(e)
        });
    }

    render() {
        return (
            <Full>
                <Form onSubmit={this.Login}>
                    <h1>Sign in</h1>
                    <Row>
                        <input
                            required
                            id="login"
                            type="text"
                            minLength="3"
                            maxLength="20"
                            placeholder="Login"
                        />
                    </Row>
                    <Row>
                        <input
                            required
                            id="pass"
                            minLength="3"
                            maxLength="20"
                            type="password"
                            placeholder="Password"
                        />
                    </Row>
                    <button data-title="Sign In" />
                </Form>
            </Full>
        )
    }

    Login = e => {
        e.preventDefault();
        let login = document.getElementById('login').value.trim();
        let pass = document.getElementById('pass').value.trim();

        axios.post('/api/login', {
            login,
            pass
        }).then(data => {
            data.data.message === 'Right authentication' ?
                this.props.history.push('/admin/home')
                :
                Swal.fire({
                    type: 'error',
                    confirmButtonText: 'Ok',
                    title: 'Authentication Error!',
                    text: 'Wrong login or password',
                })

        })
    }
}

export default withRouter(Login);
